import { $vfm } from 'vue-final-modal'
import SelectContentModal from "../Modals/SelectContentModal.vue";

export default function useSelectContentModal(callback) {

  const close = () => {
    $vfm.hideAll().then(r => {})
  }

  const open = () => {
    $vfm.show({
      component: SelectContentModal,
      bind: { callback, close }
    })
  }

  return {
    open,
    close
  }
}
